import { RangeSlider } from "../../ui";
import {useAppState} from "../../context";
import {CategoryType} from "../../types/index";
import useCatalogFilterParams from "./useCatalogFilterParams.ts";

const FilterPanel = () => {
    const [categories] = useAppState<CategoryType[]>('categories', []);
    const [{price, amount, duration}] = useAppState<{[key: string]: {min: number, max: number}}>('filterParams', {});
    const { filters, updateFilter } = useCatalogFilterParams();


    // Update filters when user interacts with the UI
    const handleCategoryChange = (categoryId: number) => {
        const currentCategories = filters.categories || [];
        const newCategories = currentCategories.includes(categoryId)
            ? currentCategories.filter(id => id !== categoryId)
            : [...currentCategories, categoryId];

        updateFilter('categories', newCategories);
    };

    const handleAmountChange = (values: [number, number]) => {
        updateFilter('amount', values);
    };

    const handleDurationChange = (values: [number, number]) => {
        updateFilter('duration', values);
    };

    const handlePriceChange = (values: [number, number]) => {
        updateFilter('price', values);
    };

    // Format function for Duration
    const formatDuration = (value: number) => {
        const minutes = Math.floor(value / 60).toString().padStart(2, '0');
        const seconds = Math.floor(value % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`; // Time format
    };

    return (
        <div className="catalog__filter">
            <label htmlFor="show-filter" className="catalog__filter-overlay-trigger" title="Close filters"></label>
            <div className="catalog__filter-inner">
                <div className="catalog__filter-head">
                    <label htmlFor="show-filter" className="catalog__filter-close" title="Close filters">
                        <svg role="img" className="catalog__filter-close-ico">
                            <use href="./img/sprite.svg#cross"></use>
                        </svg>
                    </label>
                </div>
                <div className="catalog__filter-body filter">
                    {/* Category Filter */}
                    <div className="filter__block">
                        <span className="filter__title">Category</span>
                        <div className="filter__content">
                            <div className="filter__items">
                                {categories.map((category, index) => (
                                    <label className="filter__item radiocheck" key={index}>
                                        <input
                                            value={`${category.id}`}
                                            type="checkbox"
                                            className="radiocheck__input"
                                            checked={filters.categories?.includes(category.id) || false}
                                            onChange={() => handleCategoryChange(category.id)}
                                        />
                                        <span className="filter__item-text radiocheck__text">
                                            {category.name}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Amount Filter */}
                    <div className="filter__block">
                        <div className="filter__title">Amount</div>
                        <div className="filter__content">
                            <RangeSlider
                                {...amount}
                                defaultValue={filters.amount || Object.values(amount) as [number, number]}
                                onChange={handleAmountChange}
                                textFormat={(value) => value.toLocaleString()} // Optional: Format number (e.g., with commas)
                                suffix={([,value]) => `picture${value !== 1 ? 's' : ''}`} // Dynamic pluralization for "picture(s)"
                            />
                        </div>
                    </div>

                    {/* Duration Filter */}
                    <div className="filter__block">
                        <div className="filter__title">Duration</div>
                        <div className="filter__content">
                            <RangeSlider
                                {...duration}
                                defaultValue={filters.duration || Object.values(duration) as [number, number]}
                                onChange={handleDurationChange}
                                textFormat={formatDuration} // Time format for duration
                                suffix="min" // Suffix for duration
                            />
                        </div>
                    </div>

                    {/* Price Filter */}
                    <div className="filter__block">
                        <div className="filter__title">Price</div>
                        <div className="filter__content">
                            <RangeSlider
                                {...price}
                                defaultValue={filters.price || Object.values(price) as [number, number]}
                                onChange={handlePriceChange}
                                textFormat={(value) => `$${value.toLocaleString()}`} // Currency format for price
                            />
                        </div>
                    </div>
                </div>
                <div className="catalog__filter-foot">
                    <label htmlFor="show-filter" className="btn btn_cta">Apply</label>
                </div>
            </div>
        </div>
    );
};

export default FilterPanel;
